// Akıllı Depo Ekle / Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.smartWarehouse';

export const wmsSmartWarehouseGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Akıllı depo nasıl eklenir ve düzenlenir?'),
  intro: t(`${G}.intro`, 'Bu pencerede akıllı deponun kimlik bilgilerini, lokasyon yapısını ve siparişlerin depoya nasıl düşeceğini belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yeni Akıllı Depo Ekle / Düzenle'),
    body: t(`${G}.regions.body`, 'Depo bilgileri ve ayarlar'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Ad ve iletişim bilgileri'),
      text: t(`${G}.s1.text`, 'Depo Adı zorunludur; boşken Kaydet düğmesi açılmaz. Adres, Telefon, Sorumlu Kişi ve Açıklama isteğe bağlıdır ve yalnız bilgi amaçlıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şube bağlantısı'),
      text: t(`${G}.s2.text`, '"Şube (Opsiyonel)" listesinden deponun hangi şubeye ait olduğunu seçebilirsiniz. Boş bırakılırsa depo şirket geneline ait kalır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Lokasyon modeli, rota ve kapasite'),
      text: t(`${G}.s3.text`, 'Lokasyon Modeli deponun kaç seviyeli adreslendiğini belirler: "Bölge > Peron > Raf (3 Seviye)" ya da "Bölge > Peron > Raf > Kat > Bölme (5 Seviye)". Rota Stratejisi toplayıcının raflar arasında izleyeceği yolu belirler; şu an "S-Shape + Koridor Atlama" kullanılır. Toplam Kapasite isteğe bağlıdır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Varsayılan depo olarak ayarla" işaretlenirse şirketteki diğer depoların varsayılan işareti kaldırılır; aynı anda yalnız bir varsayılan depo olur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Pazaryeri kanalları ve otomatik aktarım (yalnız düzenlemede)'),
      text: t(`${G}.s4.text`, 'Kayıtlı bir depoyu düzenlerken "Açık pazaryeri kanalları" ve "Otomatik WMS Aktarımı" bölümleri görünür. İşareti kaldırılan kanallar toplama ve paketleme ekranında gizlenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Otomatik aktarım açıkken pazaryeri / site siparişleri yalnız seçili kanallardan, "Tetikleyici Durum"a (Onaylandığında, Ödeme Alındığında, Sipariş Alındığında) gelince bu depoya düşer. Açıkken en az bir kanal seçilmelidir.'),
        t(`${G}.s4.tip2`, '"Öncelik" (Normal, Yüksek, Acil) otomatik düşen siparişlerin başlangıç önceliğidir.'),
        t(`${G}.s4.tip3`, 'Yeni depo eklerken bu bölüm görünmez; depoyu kaydettikten sonra düzenleyerek ayarlayın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" depoyu oluşturur veya günceller; düzenlemede kanal ve otomatik aktarım ayarları da aynı anda kaydedilir. Sonra listedeki harita simgesiyle lokasyonları kurmaya geçin.'),
    },
  ],
});
